import {
  FETCH_SESSION_PLANS_REQUEST,
  FETCH_SESSION_PLANS_SUCCESS,
  FETCH_SESSION_PLANS_FAILURE,
} from './actions';
import { Map } from 'immutable';
import SessionPlan from './model';
import { ApiResponseHelper } from 'omni-common-ui';

export default function sessions(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_SESSION_PLANS_REQUEST:
      return state;
    case FETCH_SESSION_PLANS_SUCCESS:
      return onSuccess(state, action);
    case FETCH_SESSION_PLANS_FAILURE:
      return state;
    default:
      return state;
  }
}

function onSuccess(state, action) {
  let newState = state;
  action.payload.forEach((sessionPlan, index) => {
    const from = Object.assign({}, sessionPlan, { index: index + 1, groupId: action.groupId });
    const sessionModel = SessionPlan.create(from);
    newState = newState.set(sessionModel.id, sessionModel);
  });

  return newState;
}

export function updateGroupSessionPlansAttribute(sessionPlans, action) {
  switch (action.type) {
    case FETCH_SESSION_PLANS_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_SESSION_PLANS_SUCCESS:
      return onSessionPlansSuccess(sessionPlans, action);
    case FETCH_SESSION_PLANS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return sessionPlans;
  }
}

function onSessionPlansSuccess(sessionPlans, action) {
  const sessionPlansIds = action.payload.filter(
    (sessionPlan) => ! sessionPlan.isCancelled)
    .map((sessionPlan) => `${sessionPlan.id}`); // stringify
  return ApiResponseHelper.create(sessionPlansIds);
}



// WEBPACK FOOTER //
// ./data/SessionPlans/reducer.js